<template>
<div>
<div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" @click="closeNav">&times;</a>
  <a v-b-modal.modal-1 >About</a>
  <a v-b-modal.modal-2>Disclaimer</a>
  <a v-b-modal.modal-3>Contact</a>
</div>
<div class="col-md-12 d-flex justify-content-between">
<h5 class="d-flex align-items-end text-danger" style="padding: 0px;!important;"><img src="../../public/img/logo_Smoke_Dispersion.png" height="80"> <strong class="p-1" style="border-style: solid;border-width: 1px;"> Case Studies</strong> </h5>
<span class="burger-menu" align-v="center" @click="openNav">&#9776;</span>
</div>
<b-modal id="modal-1" size="xl" title="About" ok-only >
    <p class="my-4" style="text-align: justify;">Biomass burning and ignition of wildfires are both related to climate change considerations since an increase in global temperature is expected to increase the frequency of occurrence for wild fires. Emitted biomass particles are in turn assumed to be major climate regulators playing a significant role in radiative transfer in the atmosphere and also in cloud processes. Improving our understanding and forecasting capability on these natural hazards is important for estimating future biomass emissions and their use in atmospheric models. Significant health implications are also related to public exposure in increased smoke concentrations. In this context a rather local wildfire or industry/accident fire may have serious effects for the greater area due to the transportation of smoke particles. Critical factors that determine the fate of the smoke plumes include wind patterns, atmospheric stability, mixing height, severity and duration of the fires and initial plume rise. Forecasting of fire smoke dispersion is provided through a synergistic remote sensing / modeling technique.
      <br><br>
    Detailed ignition, duration and locations of the fire spots are obtained online from the Fire Monitoring Service of the National Observatory of Athens. This information is provided every five (5) minutes from the MSG SEVIRI instrument and is used as a triggering input to the modeling applications. Smoke dispersion is computed with the Lagrangian dispersion model FLEXPART driven by WRF-ARW meteorological output at a resolution of 4×4 km over Greece.</p>
</b-modal>
<b-modal id="modal-2" size="xl" title="Disclaimer" ok-only>
  <p class="my-4" style="text-align: justify;">
    The user assumes the entire risk related to its use of this data. BEYOND/NOA is providing this data "as is" and disclaims any and all warranties, whether express or implied, including (without limitation) any implied warranties of merchantability or fitness for a particular purpose. In no event will BEYOND/NOA be liable to you or to any third party for any direct, indirect, incidental, consequential, special or exemplary damages or lost profit resulting from any use or misuse of this data.
  </p>
</b-modal>
<b-modal id="modal-3" size="xl" title="Contact" ok-only>
  <p class="my-4" style="text-align: justify;">
      Contact persons:
      <br><br>
      <a class="contact_link" href="mailto:nbartsotas@noa.gr">Nikolaos S. Bartsotas</a> and <a class="contact_link" href="mailto:kontoes@noa.gr">Charalambos (Haris) Kontoes</a>
  </p>
</b-modal>
</div>

</template>

<script>

export default ({
data() {
    return {
    
    }  
  },
  methods:{
    closeNav(){
      document.getElementById("mySidenav").style.width = "0";
      
    },
    openNav(){
       document.getElementById("mySidenav").style.width = "250px";
      
    }
  }
})
</script>

<style>
.active {
    background: #b8010100 !important;
    color: #05c936 !important;
  }
a{
  color: #c0c0c0 !important;
}
a:hover{
  color: #2151aa !important;
}
.contact_link{
   color: #2151aa !important;
}




.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1001;
  top: 0;
  right: 0;
  background-color: #99A499;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 30px;
  color: #FFF!important;
  display: block;
  transition: 0.3s;
  font-weight: 500;
}

.sidenav a:hover {
  color: #000!important;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

.burger-menu {
    font-size: 30px;
    cursor: pointer;
    background: rgb(153, 164, 153);
    color: #FFF;
    padding: 0px 15px;
    margin: 20px 0px;
}
.modal-backdrop{
  opacity: 0.5!important;
}
.modal-title{
 font-size: 30px !important;
}
.modal-body{
  font-size: 18px !important;
}
</style>